import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAqyS6u3-UU-n-7_o5wR6KEkr0wWKmJYc8",
  authDomain: "rizes-a0384.firebaseapp.com",
  projectId: "rizes-a0384",
  storageBucket: "rizes-a0384.firebasestorage.app",
  messagingSenderId: "1034670205487",
  appId: "1:1034670205487:web:244f63b0f53ab3b3d934da",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;